import { cn } from '@tebuto/lib/utils'
import SmallText from '@tebuto/typography/SmallText'

export type NoEntryVariant = 'primary' | 'success' | 'warning' | 'error' | 'info'

interface NoEntryProps {
    text: string
    variant?: NoEntryVariant
    className?: string
    icon?: React.ReactNode
    'data-testid'?: string
}

const variantStyles: Record<NoEntryVariant, { container: string; text: string }> = {
    primary: {
        container: 'border-primary-300 bg-primary-50/50',
        text: 'text-primary-brand'
    },
    success: {
        container: 'border-emerald-300 bg-emerald-50/50',
        text: 'text-emerald-600'
    },
    warning: {
        container: 'border-amber-300 bg-amber-50/50',
        text: 'text-amber-600'
    },
    error: {
        container: 'border-red-300 bg-red-50/50',
        text: 'text-red-600'
    },
    info: {
        container: 'border-sky-300 bg-sky-50/50',
        text: 'text-sky-600'
    }
}

export default function NoEntry({
    text,
    variant = 'primary',
    className = '',
    icon,
    'data-testid': testId
}: NoEntryProps) {
    const styles = variantStyles[variant]

    return (
        <div
            data-testid={testId}
            className={cn(
                'text-center w-full py-4 px-2 border rounded-lg flex items-center justify-center gap-2',
                styles.container,
                className
            )}
        >
            {icon && <span className="shrink-0">{icon}</span>}
            <SmallText className={cn('font-medium', styles.text)}>{text}</SmallText>
        </div>
    )
}
